import { useState } from 'react';
import { faqData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function FaqSection() {
  const ref = useScrollReveal();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            关于下载与使用的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIdx === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}